var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.24 10H23.76C23.892 10 24 9.87727 24 9.72727V7.27273C24 7.12273 23.892 7 23.76 7H10.24C10.108 7 10 7.12273 10 7.27273V9.72727C10 9.87727 10.108 10 10.24 10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50366 16.9265L0.116347 12.2615C0.080122 12.2305 0.0508092 12.1909 0.0306455 12.1455C0.0104818 12.1002 0 12.0504 0 12C0 11.9496 0.0104818 11.8998 0.0306455 11.8545C0.0508092 11.8091 0.080122 11.7695 0.116347 11.7385L5.50366 7.07347C5.70702 6.89915 6 7.05452 6 7.33495V16.665C6 16.9455 5.70358 17.1009 5.50366 16.9265Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7601 17H10.24C10.108 17 10 16.8773 10 16.7273V14.2727C10 14.1227 10.108 14 10.24 14H23.7601C23.8921 14 24.0001 14.1227 24.0001 14.2727V16.7273C24.0001 16.8773 23.8921 17 23.7601 17Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.240061 0H23.7601C23.8921 0 24.0001 0.122727 24.0001 0.272727L24 2.72727C24 2.87727 23.892 3 23.76 3H0.24C0.108 3 0 2.87727 0 2.72727L6.04987e-05 0.272727C6.04987e-05 0.122727 0.108061 0 0.240061 0Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.240061 21H23.7601C23.8921 21 24.0001 21.1227 24.0001 21.2727L24 23.7273C24 23.8773 23.892 24 23.76 24H0.24C0.108 24 0 23.8773 0 23.7273L6.04987e-05 21.2727C6.04987e-05 21.1227 0.108061 21 0.240061 21Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/menuClose.cd3803fbfdfff6787f55880f422bafd5.svg";
export { ForwardRef as ReactComponent };